import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterForm, ClosedAlphaNotice } from '../components';
import './RegisterPage.css';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const isRegistrationEnabled =
    import.meta.env.VITE_REGISTRATION_ENABLED !== 'false';

  const handleRegistrationSuccess = () => {
    // Redirect to welcome page after successful registration since new user has 0 properties
    navigate('/welcome');
  };

  const handleLoginRedirect = () => {
    // Redirect to login page
    navigate('/login');
  };

  return (
    <div className="register-page">
      <div className="register-container">
        {isRegistrationEnabled ? (
          <RegisterForm
            onSuccess={handleRegistrationSuccess}
            onLoginRedirect={handleLoginRedirect}
          />
        ) : (
          <ClosedAlphaNotice onBackToLogin={handleLoginRedirect} />
        )}
      </div>
    </div>
  );
};

export default RegisterPage;
